<template>
  <footer
    :class="{
      [$style.centerModalButton] : centered,
      [$style.modalFooter] : true,
    }"
  >
    <slot name="footerComponent" />
    <a
      v-if="kbLink"
      :class="$style.kbLink"
      :href="kbLink"
      rel="noopener noreferrer"
      target="_blank"
      @click="handleKbLinkClick"
    >
      {{ kbLinkText }}
    </a>
    <a
      v-if="cancelText"
      :class="$style.cancelLink"
      data-test-id="ModalCancelLink"
      @click="handleClose"
    >
      {{ cancelText }}
    </a>
    <FlatActionButton
      v-if="mainActionText"
      :action="handleMainAction"
      :buttonClass="['btnDefault', (mainActionAttention ? 'btnAlert' : 'btnCTA')]"
      data-test-id="ModalActionButton"
      :disabled="!enableMainAction"
      :loading="loading"
      :text="mainActionText"
    />
  </footer>
</template>

<script>
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';

export default {
  name: 'ModalFooter',
  components: {
    FlatActionButton,
  },
  props: {
    cancelText: {
      default: '',
      type: String,
    },
    centered: {
      default: false,
      type: Boolean,
    },
    enableMainAction: {
      default: true,
      type: Boolean,
    },

    /**
     * @todo This prop should be optional with a default value of closing the
     * modal.
     */
    handleClose: {
      required: true,
      type: Function,
    },

    /**
     * @todo This prop should be optional with a default value of closing the
     * modal.
     */
    handleMainAction: {
      required: true,
      type: Function,
    },
    kbLink: {
      default: '',
      type: String,
    },
    kbLinkText: {
      default: 'Read the Knowledge Base',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    mainActionAttention: {
      default: false,
      type: Boolean,
    },

    /**
     * @todo The mainActionText should be optional. The markup above will _not_
     * render the main action button if there is no mainActionText! And it's OK
     * to just display a modal with no action button.
     */
    mainActionText: {
      type: String,
      required: true,
    },
  },

  methods: {
    handleKbLinkClick() {
      this.$emit('kbLinkClicked');
    },
  },
};
</script>

<style scoped module>
@value (greyDark1) from '~css/colors.css';

.centerModalButton.modalFooter {
  justify-content: center;
}

.modalFooter {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding: 30px;
  position: relative;
}

.kbLink {
  font-style: italic;
  font-weight: 600;
  left: 35px;
  letter-spacing: 0.2px;
  margin-top: 3px;
  padding-right: 8px;
  position: absolute;
}

.kbLink.noSpace {
  padding-right: 4px;
}

.kbLink:focus,
.kbLink:hover {
  color: jcInformationalBase;
  text-decoration: none;
}

.kbLink i.jc-tool-kb {
  font-size: 25px;
}

.kbLink i.jc-tool-kb:focus {
  outline: 0;
}

.cancelLink {
  color: greyDark1;
  cursor: pointer;
  display: inline-block;
  font-size: 0.923em;
  font-style: normal;
  margin-right: 25px !important;
  text-decoration: underline;
  user-select: none;
}

.cancelLink:hover {
  color: greyDark1;
}
</style>
